import type { ReactNode } from 'react'

import type { StylableElementProps } from '@subaio/components'

import { Container } from './Container'
import { Icon } from './Icon'

type Props = StylableElementProps & {
	hasError: boolean
	hasFocus?: boolean | undefined
	errorMessage?: ReactNode
}

export const InputError = ({ hasError, hasFocus = false, errorMessage, ...rest }: Props) => (
	<Container isVisible={hasError} hasFocus={hasFocus} {...rest}>
		{hasError && (
			<>
				<Icon size={20} />
				{errorMessage}
			</>
		)}
	</Container>
)
